import { ActivatedRoute, Route, Router } from '@angular/router';
import { ConnectionDetail, ConnectionsService, SenderConnectionProduct } from './../../Services/connections.service';
import { Component, OnInit } from '@angular/core';
import { ApplicationUser, AuthConfig, AuthService, ResponseObject } from 'src/app/Services/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Artist } from 'src/app/Services/artists.service';
import { DashboardService } from 'src/app/Services/dashboard.service';
import { ConfirmationService } from 'primeng/api';
import { NotificationsService } from 'src/app/Services/shared/notifications.service';
import { NotificationTypes } from 'src/app/app.enums';
import { MessagingService } from 'src/app/Services/messaging.service';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-connection-request',
    templateUrl: './connection-request.component.html',
    styleUrls: ['./connection-request.component.css'],
    providers: [ConnectionsService, DashboardService],
    standalone: false
})
export class ConnectionRequestComponent implements OnInit {
  public ArtistId!: string;
  public galleryId!: string;
  public artist: Artist = {} as Artist;
  public authConfig: AuthConfig = {};
  public connectionId!: string;
  public isAcceptInviteExecuted: boolean = false;
  public isAccepted: boolean = false;
  public apiError: string | null = null;
  public connectionData!: ConnectionDetail;
  public gallery: ApplicationUser | undefined;
  public galleryAddress: string = '';
  public showCommentDialog: boolean = false;
  public formData!: InviteAcceptanceCommentRequest;
  public showRejectCommentDialog: boolean = false;
  public selectedCommentField:  'Accept' | 'Reject' | null = null;
  public displayEmojiDialog: boolean = false;
  public selectedTabIndex: number = 0; // Initialize with the index of the first tab

  constructor(private route: ActivatedRoute,
    private router: Router,
    private confirmationService: ConfirmationService,
    private ngxSpinnerService: NgxSpinnerService,
    private notificationService: NotificationsService,
    private authService: AuthService,
    private messagingService: MessagingService,
    private connectionsService: ConnectionsService,
    private spinnerService: NgxSpinnerService,
    private transloco: TranslocoService) {
    this.connectionData = new ConnectionDetail();
    this.formData = new InviteAcceptanceCommentRequest();
  }

  public ngOnInit(): void {
    this.route.params.subscribe((params) => {
      if (params['connectionId']) {
        this.connectionId = params['connectionId'];
        this.connectionDetails(this.connectionId);
      }
    });
  }

  markasreadNotificaion(): void {
    this.messagingService.markasreadNotificaion(this.connectionId).subscribe(
      (data) => {
        console.log(data)
      },
      (error) => {
        console.error('Error fetching notifications:', error);
      }
    );
  }

  private connectionDetails(connectionId: string) {
    this.spinnerService.show();
    this.connectionsService.getConnectionDetail(connectionId).subscribe((response: ConnectionDetail) => {
      this.connectionData = response;
      this.markasreadNotificaion()
      console.log(this.connectionData);
      this.spinnerService.hide();
    }, error => { console.error(error); this.spinnerService.hide(); });
  }

  public confirmInviteDialog(){
    this.showCommentDialog = true;    
  }

  public confirmInvite() {
    this.showCommentDialog = true;
    this.spinnerService.show();
    this.connectionsService.acceptConnectionRequest(this.connectionId, this.formData).subscribe((response: ResponseObject) => {
      this.spinnerService.hide();
      console.log(response);
      this.isAccepted = response.Success;
      if (response.Success) {

        this.notificationService.showNotification(this.transloco.translate('connectionRequest.successTitle'), this.transloco.translate('connectionRequest.connectedSuccessfully'), NotificationTypes.Success);

        if (this.authService.isGallery()) {
          this.router.navigate(['/galleries/connected-artists']);
          return;
        } else if (this.authService.isArtist()) {
          this.router.navigate(['/artists/connected-galleries']);
          
          return;
        }
      } else {
        this.notificationService.showNotification(this.transloco.translate('connectionRequest.errorTitle'), response.ResponseMessage, NotificationTypes.Error);
        console.error(response.ResponseMessage);
        this.apiError = response.ResponseMessage;
      }
      this.isAcceptInviteExecuted = true;
      this.formData = new InviteAcceptanceCommentRequest();
    }, error => {
      console.error(error);
      this.spinnerService.hide();
    });
  }

  public rejectInvitationDialog(){
    this.showRejectCommentDialog = true;
  }

  public rejectInvitation() {
    this.ngxSpinnerService.show();
        this.connectionsService.rejectInvitation(this.connectionData.ArtistId!, this.connectionData.GalleryId, this.formData!).subscribe((res: ResponseObject) => {
          this.ngxSpinnerService.hide();
          if (res.Success) {
            this.showRejectCommentDialog = false;
            this.formData = new InviteAcceptanceCommentRequest();
            if (this.authService.isGallery()) {
              this.router.navigate(['/galleries/connected-artists']);
              return;
            } else if (this.authService.isArtist()) {
              this.router.navigate(['/artists/connected-galleries']);
              return;
            }
            this.notificationService.showNotification(this.transloco.translate('connectionRequest.successTitle'), this.transloco.translate('connectionRequest.connectionRejected'), NotificationTypes.Success);
          } else { this.notificationService.showNotification(this.transloco.translate('connectionRequest.errorTitle'), res.ResponseMessage, NotificationTypes.Error); }
        }, (error) => { console.error('Error Connection Rejection .:', error); this.ngxSpinnerService.hide(); this.notificationService.showNotification(this.transloco.translate('connectionRequest.errorTitle'), this.transloco.translate('connectionRequest.removeArtistError'), NotificationTypes.Error); });
  }

  public closeRejectDialog(){
    this.showRejectCommentDialog = false;
    this.formData = new InviteAcceptanceCommentRequest();
  }





  public openEmojiDialog(commentField: 'Accept' | 'Reject') {
    this.selectedCommentField = commentField;
    this.displayEmojiDialog = true;
  }

  public addEmoji(emoji: string) {
    console.log('Selected emoji:', emoji);
    if (this.selectedCommentField === 'Accept') {
      this.formData.InviteAcceptanceComment = (this.formData.InviteAcceptanceComment || '') + emoji;
    } else if (this.selectedCommentField === 'Reject') {
      this.formData.InviteRejectionComment = (this.formData.InviteRejectionComment || '') + emoji;
    }
    this.displayEmojiDialog = false;
  }

  public closeEmojiDialog($event:any) {
    this.displayEmojiDialog = false;
  }

}
export class InviteAcceptanceCommentRequest{
  InviteAcceptanceComment?: string;  
  InviteRejectionComment?: string;
}